import _ from "lodash";
import React from "react";
import {
  EnglishDuotone,
  HindiDuotone,
  FrenchDuotone,
  MandarinDuotone,
  SpanishDuotone,
  CasDuotone,
  TheoryofKnowledgeDuotone,
  GeographyDuotone,
  CivicsDuotone,
  HistoryDuotone,
  BiologyDuotone,
  ChemistryDuotone,
  PhysicsDuotone,
  MathematicsDuotone,
  BriefcaseDuotone,
  ExtendedEssayDuotone,
  MathsDuotone,
  SportsDuotone,
  ArtDuotone,
  MusicDuotone,
  DanceDuotone,
  ActionsDuotone,
  DesignDuotone,
  OpenBookDuotone,
  LanguageAcquisitionDuotone,
  GlobalContextDuotone,
  PhysicalHealthEducationDuotone,
  LanguageLiteratureDuotone,
  SubjectGenericDuotone,
  KoreanDuotone,
  SciencesDuotone,
  FormsOfIntegrationDuotone,
  EnvelopePlainOutlined,
  LinkOutlined,
  RefreshArrowOutlined,
  LogoutOutlined,
  DisableOutlined,
  AddCircleOutlined,
  PrintOutlined,
  DownloadOutlined,
  EnglishOutlined,
  PhysicsOutlined,
  MathematicsOutlined,
  MathOutlined,
  GlobeOutlined,
  WeightOutlined,
  ScrollLetterOutlined,
  PortfolioOutlined,
  EeOutlined,
  CasOutlined,
  TheoryofKnowledgeOutlined,
  BallOutlined,
  PaintBrushOutlined,
  DanceOutlined,
  MusicOutlined,
  TeacherResourceOutlined,
  LoudspeakerOutlined,
  LanguageOutlined,
  OpenBookTextOutlined,
  PageBookmarkOutlined,
  PuzzlePieceOutlined,
  DnaOutlined,
  FunnelOutlined,
  ScienceOutlined,
  MinusCircleOutlined,
} from "@toddle-edu/ds-icons";
import ACLStore from "lib/aclStore";
import {
  getFamilyFeedQueryFilters,
  getFamiliesFilters,
} from "ManageFamily/modules/ManageFamilyModule";
import { getUserCourseMapFilters } from "Administrator/modules/Utils";
import { disableEditForMapleBearChildOrg } from "Courses/modules/utils";
import {
  REMOVE_CLASS_LEVEL_MODULE_SETTINGS,
  ENABLE_STUDENT_BLOCKING,
  MANAGE_CLASS_SETTINGS_PERMISSION,
  ASSIGN_CONTENT_TO_STUDENTS_IN_CLASS_SETTINGS_PERMISSION,
  MANAGE_SIGNIN_CODES_AND_LOGOUT_STUDENTS,
  VIEW_DOWNLOAD_STUDENT_AND_FAMILY_INVITE_PERMISSION,
  MANAGE_CLASS_SETTINGS_STAFF_PERMISSION,
  MANAGE_CLASS_SETTINGS_STUDENT_PERMISSION,
  SUBJECT_SETTINGS_ACCESS_PERMISSION,
  MANAGE_GRADE_BOUNDARIES_PERMISSION,
  MANAGE_ASSESSMENT_CATEGORY_PERMISSION,
  MANAGE_MYP_CRITERIA_PHASE_SELECTION_PERMISSION,
  GRADING_VISIBILITY_SETTINGS_PERM,
  GRADING_VISIBILITY_SETTINGS_V2_PERM,
  ENABLE_STUDENT_TIMETABLE_PERMISSION,
} from "Constants/permissionConstants";
import { isPortfolioEnabled } from "Post/utils";
import { generateRandomId } from "Utils";
import update from "immutability-helper";
import { getIsAdminByRole } from "lib/staffPermissionUtils";
import ACLStorage from "lib/aclService";
import IconAvatar from "../components/IconAvatar";
import { isTimetableModuleEnabled } from "Courses/modules/utils";
import {
  getIsFamilyInviteOptionsDisabled,
  isBulkActionsEnabled,
  getIsRnPConfigurationEnabled,
} from "Utils/ACLStoreUtils";

export const getIconObject = ({
  size = "small",
  containerStyle = {},
  hasBackground = true,
}) => {
  const iconObject = {
    EnglishDuotone: {
      iconName: "EnglishDuotone",
      color: "pink",
      components: (
        <EnglishDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    HindiDuotone: {
      iconName: "HindiDuotone",
      color: "pink",
      components: (
        <HindiDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    FrenchDuotone: {
      iconName: "FrenchDuotone",
      color: "pink",
      components: (
        <FrenchDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    KoreanDuotone: {
      iconName: "KoreanDuotone",
      color: "pink",
      components: (
        <KoreanDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    SpanishDuotone: {
      iconName: "SpanishDuotone",
      color: "pink",
      components: (
        <SpanishDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    MandarinDuotone: {
      iconName: "MandarinDuotone",
      color: "pink",
      components: (
        <MandarinDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    LanguageAcquisitionDuotone: {
      iconName: "LanguageAcquisitionDuotone",
      color: "pink",
      components: (
        <LanguageAcquisitionDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
    BiologyDuotone: {
      iconName: "BiologyDuotone",
      color: "blue",
      components: (
        <BiologyDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    PhysicsDuotone: {
      iconName: "PhysicsDuotone",
      color: "blue",
      components: (
        <PhysicsDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    ChemistryDuotone: {
      iconName: "ChemistryDuotone",
      color: "blue",
      components: (
        <ChemistryDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    SciencesDuotone: {
      iconName: "SciencesDuotone",
      color: "blue",
      components: (
        <SciencesDuotone
          hasBackground={hasBackground}
          size={size}
          color="blue"
          containerStyle={containerStyle}
        />
      ),
    },
    MathematicsDuotone: {
      iconName: "MathematicsDuotone",
      color: "violet",
      components: (
        <MathematicsDuotone
          hasBackground={hasBackground}
          size={size}
          color="violet"
          containerStyle={containerStyle}
        />
      ),
    },
    MathsDuotone: {
      iconName: "MathsDuotone",
      color: "violet",
      components: (
        <MathsDuotone
          hasBackground={hasBackground}
          size={size}
          color="violet"
          containerStyle={containerStyle}
        />
      ),
    },
    GeographyDuotone: {
      iconName: "GeographyDuotone",
      color: "yellow",
      components: (
        <GeographyDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    CivicsDuotone: {
      iconName: "CivicsDuotone",
      color: "yellow",
      components: (
        <CivicsDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    HistoryDuotone: {
      iconName: "HistoryDuotone",
      color: "yellow",
      components: (
        <HistoryDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    GlobalContextDuotone: {
      iconName: "GlobalContextDuotone",
      color: "yellow",
      components: (
        <GlobalContextDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    BriefcaseDuotone: {
      iconName: "BriefcaseDuotone",
      color: "yellow",
      components: (
        <BriefcaseDuotone
          hasBackground={hasBackground}
          size={size}
          color="yellow"
          containerStyle={containerStyle}
        />
      ),
    },
    ExtendedEssayDuotone: {
      iconName: "ExtendedEssayDuotone",
      color: "teal",
      components: (
        <ExtendedEssayDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    CasDuotone: {
      iconName: "CasDuotone",
      color: "teal",
      components: (
        <CasDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    TheoryofKnowledgeDuotone: {
      iconName: "TheoryofKnowledgeDuotone",
      color: "teal",
      components: (
        <TheoryofKnowledgeDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    SportsDuotone: {
      iconName: "SportsDuotone",
      color: "teal",
      components: (
        <SportsDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    ArtDuotone: {
      iconName: "ArtDuotone",
      color: "teal",
      components: (
        <ArtDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    DanceDuotone: {
      iconName: "DanceDuotone",
      color: "teal",
      components: (
        <DanceDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    MusicDuotone: {
      iconName: "MusicDuotone",
      color: "teal",
      components: (
        <MusicDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    DesignDuotone: {
      iconName: "DesignDuotone",
      color: "teal",
      components: (
        <DesignDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    ActionsDuotone: {
      iconName: "ActionsDuotone",
      color: "teal",
      components: (
        <ActionsDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    PhysicalHealthEducationDuotone: {
      iconName: "PhysicalHealthEducationDuotone",
      color: "teal",
      components: (
        <PhysicalHealthEducationDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    LanguageLiteratureDuotone: {
      iconName: "LanguageLiteratureDuotone",
      color: "teal",
      components: (
        <LanguageLiteratureDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    OpenBookDuotone: {
      iconName: "OpenBookDuotone",
      color: "teal",
      components: (
        <OpenBookDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    SubjectGenericDuotone: {
      iconName: "SubjectGenericDuotone",
      color: "teal",
      components: (
        <SubjectGenericDuotone
          hasBackground={hasBackground}
          size={size}
          color="teal"
          containerStyle={containerStyle}
        />
      ),
    },
    FormsOfIntegrationDuotone: {
      iconName: "FormsOfIntegrationDuotone",
      color: "pink",
      components: (
        <FormsOfIntegrationDuotone
          hasBackground={hasBackground}
          size={size}
          color="pink"
          containerStyle={containerStyle}
        />
      ),
    },
  };
  return iconObject;
};

export const getOutlinedIconObject = ({
  size = "small",
  containerStyle = {},
  hasBackground = true,
  className,
}) => {
  const iconObject = {
    EnglishOutlined: {
      iconName: "EnglishOutlined",
      color: "pink",
      components: (
        <IconAvatar
          size={size}
          icon={EnglishOutlined}
          color="pink"
          className={className}
        />
      ),
    },
    LanguageOutlined: {
      iconName: "LanguageOutlined",
      color: "pink",
      components: (
        <IconAvatar
          size={size}
          icon={LanguageOutlined}
          color="pink"
          className={className}
        />
      ),
    },
    DnaOutlined: {
      iconName: "DnaOutlined",
      color: "blue",
      components: (
        <IconAvatar
          size={size}
          icon={DnaOutlined}
          color="blue"
          className={className}
        />
      ),
    },
    PhysicsOutlined: {
      iconName: "PhysicsOutlined",
      color: "blue",
      components: (
        <IconAvatar
          size={size}
          icon={PhysicsOutlined}
          color="blue"
          className={className}
        />
      ),
    },
    FunnelOutlined: {
      iconName: "FunnelOutlined",
      color: "blue",
      components: (
        <IconAvatar
          size={size}
          icon={FunnelOutlined}
          color="blue"
          className={className}
        />
      ),
    },
    ScienceOutlined: {
      iconName: "ScienceOutlined",
      color: "blue",
      components: (
        <IconAvatar
          size={size}
          icon={ScienceOutlined}
          color="blue"
          className={className}
        />
      ),
    },
    MathematicsOutlined: {
      iconName: "MathematicsOutlined",
      color: "violet",
      components: (
        <IconAvatar
          size={size}
          icon={MathematicsOutlined}
          color="violet"
          className={className}
        />
      ),
    },
    MathOutlined: {
      iconName: "MathOutlined",
      color: "violet",
      components: (
        <IconAvatar
          size={size}
          icon={MathOutlined}
          color="violet"
          className={className}
        />
      ),
    },
    GlobeOutlined: {
      iconName: "GlobeOutlined",
      color: "yellow",
      components: (
        <IconAvatar
          size={size}
          icon={GlobeOutlined}
          color="yellow"
          className={className}
        />
      ),
    },
    WeightOutlined: {
      iconName: "WeightOutlined",
      color: "yellow",
      components: (
        <IconAvatar
          size={size}
          icon={WeightOutlined}
          color="yellow"
          className={className}
        />
      ),
    },
    ScrollLetterOutlined: {
      iconName: "ScrollLetterOutlined",
      color: "yellow",
      components: (
        <IconAvatar
          size={size}
          icon={ScrollLetterOutlined}
          color="yellow"
          className={className}
        />
      ),
    },
    PortfolioOutlined: {
      iconName: "PortfolioOutlined",
      color: "yellow",
      components: (
        <IconAvatar
          size={size}
          icon={PortfolioOutlined}
          color="yellow"
          className={className}
        />
      ),
    },
    EeOutlined: {
      iconName: "EeOutlined",
      color: "teal",
      components: (
        <IconAvatar
          size={size}
          icon={EeOutlined}
          color="teal"
          className={className}
        />
      ),
    },
    CasOutlined: {
      iconName: "CasOutlined",
      color: "teal",
      components: (
        <IconAvatar
          size={size}
          icon={CasOutlined}
          color="teal"
          className={className}
        />
      ),
    },
    TheoryofKnowledgeOutlined: {
      iconName: "TheoryofKnowledgeOutlined",
      color: "teal",
      components: (
        <IconAvatar
          size={size}
          icon={TheoryofKnowledgeOutlined}
          color="teal"
          className={className}
        />
      ),
    },
    BallOutlined: {
      iconName: "BallOutlined",
      color: "teal",
      components: (
        <IconAvatar
          size={size}
          icon={BallOutlined}
          color="teal"
          className={className}
        />
      ),
    },
    PaintBrushOutlined: {
      iconName: "PaintBrushOutlined",
      color: "teal",
      components: (
        <IconAvatar
          size={size}
          icon={PaintBrushOutlined}
          color="teal"
          className={className}
        />
      ),
    },
    DanceOutlined: {
      iconName: "DanceOutlined",
      color: "teal",
      components: (
        <IconAvatar
          size={size}
          icon={DanceOutlined}
          color="teal"
          className={className}
        />
      ),
    },
    MusicOutlined: {
      iconName: "MusicOutlined",
      color: "teal",
      components: (
        <IconAvatar
          size={size}
          icon={MusicOutlined}
          color="teal"
          className={className}
        />
      ),
    },
    TeacherResourceOutlined: {
      iconName: "TeacherResourceOutlined",
      color: "teal",
      components: (
        <IconAvatar
          size={size}
          icon={TeacherResourceOutlined}
          color="teal"
          className={className}
        />
      ),
    },
    LoudspeakerOutlined: {
      iconName: "LoudspeakerOutlined",
      color: "teal",
      components: (
        <IconAvatar
          size={size}
          icon={LoudspeakerOutlined}
          color="teal"
          className={className}
        />
      ),
    },
    OpenBookTextOutlined: {
      iconName: "OpenBookTextOutlined",
      color: "teal",
      components: (
        <IconAvatar
          size={size}
          icon={OpenBookTextOutlined}
          color="teal"
          className={className}
        />
      ),
    },
    PageBookmarkOutlined: {
      iconName: "PageBookmarkOutlined",
      color: "teal",
      components: (
        <IconAvatar
          size={size}
          icon={PageBookmarkOutlined}
          color="teal"
          className={className}
        />
      ),
    },
    PuzzlePieceOutlined: {
      iconName: "PuzzlePieceOutlined",
      color: "pink",
      components: (
        <IconAvatar
          size={size}
          icon={PuzzlePieceOutlined}
          color="pink"
          className={className}
        />
      ),
    },
  };

  return iconObject;
};

export const canManageClassSettings = () => {
  return ACLStorage.getPermissionValue(MANAGE_CLASS_SETTINGS_PERMISSION);
};

export const canAssignContentToStudentsInClassSettings = () => {
  return ACLStorage.getPermissionValue(
    ASSIGN_CONTENT_TO_STUDENTS_IN_CLASS_SETTINGS_PERMISSION
  );
};

export const canManageClassSettingsStaff = () => {
  return ACLStorage.getPermissionValue(MANAGE_CLASS_SETTINGS_STAFF_PERMISSION);
};

export const canManageClassSettingsStudents = () => {
  return ACLStorage.getPermissionValue(
    MANAGE_CLASS_SETTINGS_STUDENT_PERMISSION
  );
};

export const canResetStudentSignInAndFamilyInviteCodesInClassSettings = () => {
  return ACLStorage.getPermissionValue(MANAGE_SIGNIN_CODES_AND_LOGOUT_STUDENTS);
};

export const canViewStudentSignInAndFamilyInviteCodesInClassSettings = () => {
  return ACLStorage.getPermissionValue(
    VIEW_DOWNLOAD_STUDENT_AND_FAMILY_INVITE_PERMISSION
  );
};

export const canManageAssessmentCategories = () => {
  return ACLStorage.getPermissionValue(MANAGE_ASSESSMENT_CATEGORY_PERMISSION);
};

export const canManageGradeBoundaries = () => {
  return ACLStorage.getPermissionValue(MANAGE_GRADE_BOUNDARIES_PERMISSION);
};

export const canManageMYPCriteriaConfiguration = () => {
  return ACLStorage.getPermissionValue(
    MANAGE_MYP_CRITERIA_PHASE_SELECTION_PERMISSION
  );
};

export const canAccessSubjectSettings = () => {
  return ACLStorage.getPermissionValue(SUBJECT_SETTINGS_ACCESS_PERMISSION);
};

export const getMenuItems = ({
  t,
  isCurrentAcademicYearSelected,
  isFutureAcademicYearSelected,
  blockedStudentsCount,
  isArchived,
  isStudentTabVisible = true,
}) => {
  const isFamilyInviteOptionsDisabled = getIsFamilyInviteOptionsDisabled();
  const isStudentInviteCodeResetEnabled = canResetStudentSignInAndFamilyInviteCodesInClassSettings();
  const isFamilyInviteCodeResetEnabled = canResetStudentSignInAndFamilyInviteCodesInClassSettings();
  // FeatureFlag:DisableFamilyInviteForTeachers is default false and is only enabled for crawford cause they want to disable the invite family feature for teachers
  const isInviteOptionsVisible =
    (getIsAdminByRole() ||
      !ACLStore.can("FeatureFlag:DisableFamilyInviteForTeachers")) &&
    !disableEditForMapleBearChildOrg();

  const studentOptions = [
    {
      label: t("common:add_with_label", {
        label: _.toLower(t("common:student")),
      }),
      key: "ADD_STUDENT",
      disabled: isArchived,
      disabledTooltip: t("schoolSetup:cannot_add_entity_to_an_archived_class", {
        entity: t("common:lowercase", {
          text: t("common:student_plural"),
        }),
      }),
      tooltipPlacement: "top",
      icon: <AddCircleOutlined />,
      isVisible:
        !disableEditForMapleBearChildOrg() &&
        canManageClassSettingsStudents() &&
        (isCurrentAcademicYearSelected || isFutureAcademicYearSelected),
    },
    {
      label: t("schoolSetup:print_class_invite_code_pdf"),
      key: "PRINT_CLASS_CODE",
      icon: <PrintOutlined />,
      isVisible: canViewStudentSignInAndFamilyInviteCodesInClassSettings(),
    },
    {
      label: t("schoolSetup:download_student_list_xlsx"),
      key: "STUDENT_LIST",
      icon: <DownloadOutlined />,
      isVisible: true,
    },
    {
      label: t("schoolSetup:print_student_sign_in_code_pdf"),
      key: "STUDENT_SIGNIN_CODES",
      icon: <PrintOutlined />,
      isVisible:
        !ACLStore.can("Common:DisableStudentInviteCodeUsage") &&
        !disableEditForMapleBearChildOrg() &&
        canViewStudentSignInAndFamilyInviteCodesInClassSettings(),
    },
    {
      key: "BULK_UNBLOCK_STUDENTS",
      label: t("schoolSetup:unblock_student_access"),
      disabled: !blockedStudentsCount,
      disabledTooltip: t("schoolSetup:no_students_to_unblock_tooltip"),
      icon: <DisableOutlined />,
      isVisible:
        ACLStore.can(ENABLE_STUDENT_BLOCKING) &&
        (isCurrentAcademicYearSelected || isFutureAcademicYearSelected) &&
        canResetStudentSignInAndFamilyInviteCodesInClassSettings(),
    },
    {
      key: "RESET_STUDENT_SIGN_IN_CODE",
      label: t("common:reset_with_label", {
        label: _.lowerCase(t("common:student_sign_in_code_plural")),
      }),
      isDestructive: true,
      icon: <RefreshArrowOutlined />,
      isVisible:
        isStudentInviteCodeResetEnabled &&
        !disableEditForMapleBearChildOrg() &&
        (isCurrentAcademicYearSelected || isFutureAcademicYearSelected) &&
        canResetStudentSignInAndFamilyInviteCodesInClassSettings(),
    },
    {
      key: "RESET_CLASS_INVITE_CODE",
      label: t("common:reset_with_label", {
        label: t("schoolSetup:class_invite_code_for_students"),
      }),
      isDestructive: true,
      icon: <RefreshArrowOutlined />,
      isVisible:
        (isCurrentAcademicYearSelected || isFutureAcademicYearSelected) &&
        canResetStudentSignInAndFamilyInviteCodesInClassSettings(),
    },
    {
      key: "BULK_BLOCK_STUDENTS",
      label: t("schoolSetup:temporarily_block_student_access"),
      isDestructive: true,
      icon: <DisableOutlined />,
      isVisible:
        ACLStore.can(ENABLE_STUDENT_BLOCKING) &&
        (isCurrentAcademicYearSelected || isFutureAcademicYearSelected) &&
        canResetStudentSignInAndFamilyInviteCodesInClassSettings(),
    },
    {
      label: t("schoolSetup:logout_user_from_all_devices", {
        label: _.toLower(t("common:student_plural")),
      }),
      isDestructive: true,
      icon: <LogoutOutlined />,
      key: "LOGOUT_STUDENTS",
      isVisible:
        (isCurrentAcademicYearSelected || isFutureAcademicYearSelected) &&
        canResetStudentSignInAndFamilyInviteCodesInClassSettings(),
    },
  ];

  const familyOptions = [
    {
      label: t("common:print_with_label", {
        label: t("common:family_invites_for_each_student_pdf"),
      }),
      key: "FAMILY_INVITE_CODES",
      icon: <PrintOutlined />,
      isVisible:
        !disableEditForMapleBearChildOrg() &&
        canViewStudentSignInAndFamilyInviteCodesInClassSettings() &&
        !isFamilyInviteOptionsDisabled,
    },
    {
      label: t("common:download_with_label", {
        label: t("common:student_list_of_unconnected_family_xlsx"),
      }),
      key: "STUDENT_WITH_UNCONNECTED_FAMILY",
      icon: <DownloadOutlined />,
      isVisible: isStudentTabVisible,
    },
    {
      label: t("common:invite_family_members_email"),
      key: "FAMILY_INVITES_BY_EMAIL",
      icon: <EnvelopePlainOutlined />,
      isVisible:
        canManageClassSettings() &&
        isInviteOptionsVisible &&
        (isCurrentAcademicYearSelected || isFutureAcademicYearSelected) &&
        !isFamilyInviteOptionsDisabled,
    },
    {
      label: t("common:invite_family_by_class_link"),
      key: "FAMILY_INVITES_BY_LINK",
      icon: <LinkOutlined />,
      isVisible:
        ACLStore.can("FeatureFlag:ClassInviteForFamily") &&
        canManageClassSettings() &&
        isInviteOptionsVisible &&
        (isCurrentAcademicYearSelected || isFutureAcademicYearSelected) &&
        !isFamilyInviteOptionsDisabled,
    },
    {
      label: t("common:reset_with_label", {
        label: t("common:family_invite_code_plural"),
      }),
      isDestructive: true,
      icon: <RefreshArrowOutlined />,
      key: "RESET_FAMILY_CODE",
      isVisible:
        isFamilyInviteCodeResetEnabled &&
        (isCurrentAcademicYearSelected || isFutureAcademicYearSelected) &&
        !isFamilyInviteOptionsDisabled,
    },
  ];

  const options = [
    {
      label: t("common:student"),
      key: "STUDENT",
      isItemGroup: true,
      options: _.filter(studentOptions, "isVisible"),
      isVisible: isStudentTabVisible,
    },
    {
      label: t("common:family"),
      key: "FAMILY",
      isItemGroup: true,
      options: _.filter(familyOptions, "isVisible"),
      isVisible:
        (canManageClassSettings() || canManageClassSettingsStudents()) &&
        !disableEditForMapleBearChildOrg(),
    },
  ];

  return _.filter(options, "isVisible");
};

export const getIsMypPhaseSelectionVisible = ({
  isMYP,
  subject = {},
  criteriaNodes = [],
}) => {
  if (!isMYP) return false;

  const subjectGroupType = _.get(
    subject,
    "subjectGroup.type",
    _.get(subject, "type")
  );
  if (_.isEqual(subjectGroupType, "OTHERS") && _.isEmpty(criteriaNodes)) {
    return false;
  }

  return true;
};

export const getTabs = ({
  t,
  isDP,
  isPYP,
  isUBD,
  isMYP,
  isSubjectTypeEEOrCAS,
  isStudentTabVisible,
  isCore,
  isFutureAcademicYearSelected,
  type,
  canDefineGradeBoundary = true,
  subjects,
  associatedChildPlannerElementNodes,
  overrideSubjectTypeCheck = false,
  isUsingNewGradingSetupInCourses,
}) => {
  const permissionType = {
    students: isStudentTabVisible,
    assessmentCategory:
      !isUsingNewGradingSetupInCourses &&
      (isUBD || isPYP || isMYP || (isDP && !isSubjectTypeEEOrCAS)),
    classSettings:
      (!isCore || overrideSubjectTypeCheck) &&
      ACLStore.can("TeacherPortal:ClassSetting"),
    NotificationSettings:
      isPYP && ACLStore.can("Common:NotificationConfiguration"),
    manageFamily: ACLStore.can("TeacherPortal:ManageFamilyMembers"),
    timeTableConfiguration: ACLStore.can(ENABLE_STUDENT_TIMETABLE_PERMISSION),
    mypCriteriaConfiguration: getIsMypPhaseSelectionVisible({
      isMYP,
      subject: _.first(subjects),
      criteriaNodes: associatedChildPlannerElementNodes,
    }),
    moduleSettings: !ACLStore.can(REMOVE_CLASS_LEVEL_MODULE_SETTINGS),
  };

  const showClassSettingTabs = _.isEqual(type, "CLASS_SETTINGS") || !type;
  const showSubjectSettingTabs = _.isEqual(type, "SUBJECT_SETTINGS") || !type;

  const hasSingleSubject = _.size(subjects) === 1;
  const isVisibilitySettingsEnabled = ACLStore.can([
    GRADING_VISIBILITY_SETTINGS_PERM,
    GRADING_VISIBILITY_SETTINGS_V2_PERM,
  ]);

  const tabs = [
    {
      key: "students",
      route: "students",
      label: `${t("common:student_plural")}`,
      visible: permissionType.students && showClassSettingTabs,
    },
    {
      key: "family_members",
      route: "family-members",
      label: t("common:family_member_plural"),
      visible:
        permissionType.manageFamily &&
        showClassSettingTabs &&
        !isFutureAcademicYearSelected,
    },
    {
      key: "teachers",
      route: "teachers",
      label: t("common:staff_members_plural"),
      visible: showClassSettingTabs,
    },
    {
      key: "myp_criteria_configuration",
      route: "myp-criteria-configuration",
      label: t("common:myp_criteria_configuration"),
      visible:
        permissionType.mypCriteriaConfiguration && showSubjectSettingTabs,
    },
    {
      key: "assessment_categories",
      route: "assessment-categories",
      label: t("academicSetup:assessment_categories"),
      visible: permissionType.assessmentCategory && showSubjectSettingTabs,
    },
    {
      key: "grade_boundaries",
      route: "grade-boundaries",
      label: t("academicSetup:grade_boundaries"),
      visible:
        !isUsingNewGradingSetupInCourses &&
        !isPYP &&
        canDefineGradeBoundary &&
        !isSubjectTypeEEOrCAS &&
        _.isEqual(type, "SUBJECT_SETTINGS"),
    },
    {
      key: "journal",
      route: "journal",
      label: t("configuration:portfolio_settings"),
      visible:
        permissionType.classSettings &&
        showClassSettingTabs &&
        isPortfolioEnabled(), // do not show journal setting tab if portfolio is disabled,
    },
    {
      key: "notification",
      route: "notification",
      label: t("configuration:notifications_preferences"),
      visible: false,
    },
    {
      key: "timetable_configuration",
      route: "timetable-configuration",
      label: t("common:timetable_config"),
      visible:
        permissionType.timeTableConfiguration &&
        showClassSettingTabs &&
        isTimetableModuleEnabled(),
    },
    {
      key: "module",
      route: "module",
      label: _.capitalize(t("common:module_settings")),
      visible: permissionType.moduleSettings && showClassSettingTabs,
    },
    {
      key: "grading-configurations",
      route: "grading-configurations",
      label: t("course:grading_configurations"),
      visible: showSubjectSettingTabs && isUsingNewGradingSetupInCourses,
    },
    {
      key: "grading-visibility",
      route: "grading-visibility",
      label: t("common:grading_visibility"),
      visible:
        showSubjectSettingTabs &&
        isUsingNewGradingSetupInCourses &&
        isVisibilitySettingsEnabled,
    },
  ];
  return _.filter(tabs, "visible");
};

const specialCharacterCheck = classChar => {
  return /^[A-Z0-9]$/i.test(classChar);
};

export const getAcronym = className => {
  className = className?.trim();
  if (className && className?.length >= 2) {
    let i = 0;
    // prevent badly-formed class names (like c*&^# - one character then only special symbols)
    for (
      i = 0;
      i < className.length && !specialCharacterCheck(className.charAt(i));
      i++
    );

    let j = i + 1;
    for (
      j = i + 1;
      j < className.length && !specialCharacterCheck(className.charAt(j));
      j++
    );
    if (i < className.length && j < className.length)
      return _.capitalize(`${className.charAt(i)} ${className.charAt(j)}`);
  }
  return className?.charAt(0);
};

export const getStudentFeedVariables = ({ state, courseId }) => {
  const organizationId = _.get(state, "login.userInfo.org_id", "");
  const filters = {};
  const loginActiveTab = _.get(state, "login.activeTab", "");
  const curriculumProgramId = _.get(
    state,
    "platform.currentCurriculumProgram.id",
    ""
  );
  const archivalState = _.get(
    state,
    "studentPortfolio.studentFilters.archivalState",
    "ACTIVE"
  );
  const userCourseMapFilters = getUserCourseMapFilters({
    archivalState: "ALL",
  });

  const studentFeedFilters = getFamilyFeedQueryFilters({
    filters,
    loginActiveTab,
    courseId,
    curriculumProgramId,
    archivalState,
  });
  const familiesFilter = getFamiliesFilters({ filters, loginActiveTab });
  const withStaffRelation = false;
  return {
    organizationId,
    filters: studentFeedFilters,
    familyStatus: { archivalState },
    familiesFilter,
    withStaffRelation,
    userCourseMapFilters,
  };
};

export const getUpdatedData = ({
  existingData,
  selectedMappings,
  updateCourseUserMappings,
  courseId,
  selectedMappingsWithUserAndStaffName,
  isCourseBasedGradingSetup,
}) => {
  // Step 1: Remove entities based on updateCourseUserMappings
  let updatedData = _.cloneDeep(existingData);

  _.forEach(updateCourseUserMappings, mapping => {
    const { userId } = mapping;
    _.forEach(updatedData.platform.course, course => {
      _.forEach(course.userMap.edges, edge => {
        edge.node.entities = _.filter(
          edge.node.entities,
          entity => entity.user.id !== userId
        );
      });
    });
  });

  if (_.isEmpty(selectedMappings)) {
    return updatedData;
  }

  // Step 2a: Create userEntityMap based on selectedMappings
  const userEntityMapping = _.chain(selectedMappingsWithUserAndStaffName)
    .groupBy("userId")
    .map((entities, userId) => ({
      userId,
      entities: _.map(
        entities,
        ({
          userId: id,
          userFirstName: firstName,
          userMiddleName: middleName,
          userLastName: lastName,
          entityId,
          entityName,
          entityType,
        }) => ({
          id: generateRandomId(),
          user: {
            id,
            firstName,
            middleName,
            lastName,
            __typename: "Staff",
          },
          entity: {
            id: entityId,
            name: entityName,
            __typename: isCourseBasedGradingSetup
              ? "LearningCourse"
              : "Subject",
          },
          entityType,
          __typename: "CourseUserEntityMap",
        })
      ),
    }))
    .value();

  // Step 2b: Create optimisticResponse based on userEntityMapping
  const optimisticResponse = _.map(userEntityMapping, mapping => ({
    __typename: "CourseUserMapEdge",
    node: {
      id: generateRandomId(),
      entities: mapping.entities,
      isRemovedFromClass: false,
      __typename: "CourseUserMap",
    },
  }));

  // Step 2c: Update existingData with optimisticResponse
  const courseIndex = _.findIndex(existingData.platform.course, {
    id: courseId,
  });

  updatedData = update(updatedData, {
    platform: {
      course: {
        [courseIndex]: {
          userMap: {
            edges: {
              $push: optimisticResponse,
            },
          },
        },
      },
    },
  });

  return updatedData;
};

export const getSelectedCourseUserMappings = ({
  course,
  courseId,
  staffId,
  isChecked,
  staffName,
  staffNameObj,
  isCourseBasedGradingSetup,
  learningCourseId,
  learningCourseTitle,
}) => {
  const subjects = _.get(course, "subjects");
  const subjectId = _.get(_.first(subjects), "id");
  const subjectName = _.get(_.first(subjects), "name");
  const updateCourseUserMappings = [
    {
      courseId,
      userId: staffId,
      entityType: isCourseBasedGradingSetup ? "LEARNING_COURSE" : "SUBJECT",
    },
  ];
  const selectedMappings = isChecked
    ? []
    : [
        {
          courseId,
          userId: staffId,
          entityType: isCourseBasedGradingSetup ? "LEARNING_COURSE" : "SUBJECT",
          entityId: isCourseBasedGradingSetup ? learningCourseId : subjectId,
        },
      ];
  const selectedMappingsWithUserAndStaffName = isChecked
    ? []
    : [
        {
          courseId,
          userId: staffId,
          entityType: isCourseBasedGradingSetup ? "LEARNING_COURSE" : "SUBJECT",
          entityId: isCourseBasedGradingSetup ? learningCourseId : subjectId,
          entityName: isCourseBasedGradingSetup
            ? learningCourseTitle
            : subjectName,
          userName: staffName,
          userFirstName: staffNameObj?.firstName,
          userMiddleName: staffNameObj?.middleName,
          userLastName: staffNameObj?.lastName,
        },
      ];

  return {
    updateCourseUserMappings,
    selectedMappings,
    selectedMappingsWithUserAndStaffName,
  };
};

//permission constants
export const isSyncCalendarFromSISEnabled = () =>
  ACLStore.can("FeatureFlag:SyncCalendarFromSIS");

export const showStudentMessagingAccessPoint = () =>
  ACLStore.can("FeatureFlag:StudentMessagingAccessPoint");

export const showTeacherMessagingAccessPoint = () =>
  ACLStore.can("FeatureFlag:TeacherMessagingAccessPoint");

export const showFamilyMessagingAccessPoint = () =>
  ACLStore.can("FeatureFlag:FamilyMessagingAccessPoint");

export const CLASS_STAFF_BULK_ACTIONS = {
  REMOVE_STAFF_FROM_CLASS: "remove_staff_from_class",
  DOWNLOAD_LIST_OF_SELECTED_STAFF: "download_list_of_selected_staff",
};

export const getClassStaffBulkActionOptions = ({
  t,
  updateTeachersInClassPerms,
  hasNonRemovableStaff,
}) => {
  const actions = [
    {
      key: "staff",
      label: t("common:staff"),
      isItemGroup: true,
      options: [
        {
          key: CLASS_STAFF_BULK_ACTIONS.REMOVE_STAFF_FROM_CLASS,
          label: t("schoolSetup:remove_from_class"),
          icon: <MinusCircleOutlined />,
          isDestructive: true,
          visible: updateTeachersInClassPerms && !hasNonRemovableStaff,
        },
        {
          key: CLASS_STAFF_BULK_ACTIONS.DOWNLOAD_LIST_OF_SELECTED_STAFF,
          label: t("common:download_list_of_selected_entity_xlsx", {
            entity: _.toLower(t("common:staff")),
          }),
          icon: <DownloadOutlined />,
          visible: true,
        },
      ],
    },
  ];

  return _.map(actions, group => ({
    ...group,
    options: _.filter(_.get(group, "options", []), "visible"),
  }));
};

export const getTeachersFromCourseVariables = ({
  courseId,
  searchText,
  academicYearId,
  orderBy,
  rnpRoleContextDetailFilter,
}) => {
  const isBulkActionsFeatureEnabled = isBulkActionsEnabled();
  const isRnPConfigurationEnabled = getIsRnPConfigurationEnabled();

  const filters = { searchText, academicYear: academicYearId };
  const filtersWithoutSearch = { searchText: "", academicYear: academicYearId };

  return {
    ids: [courseId],
    filters,
    ...(isBulkActionsFeatureEnabled ? { filtersWithoutSearch } : {}),
    orderBy,
    rnpRoleContextDetailFilter,
    includeAdminCount:
      !isRnPConfigurationEnabled && isBulkActionsFeatureEnabled,
    includeMappedToMe: isBulkActionsFeatureEnabled,
  };
};

//string constants
export const TIMETABLE_CONFIG_TAB = "timetable-configuration";
export const SUBJECT_SELECTION_STEP = "subjectSelectionStep";
export const TEACHER_SELECTION_STEP = "teacherSelectionStep";
